import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-800" data-id="element-97">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-98">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-99">
          ✈️ MEGAPACK TÉCNICO EN AERONÁUTICA 360™
        </h4>

        <p className="text-slate-300 mb-6" data-id="element-100">
          Hecho por especialistas, para docentes de aeronáutica técnica de toda
          Argentina.
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-101">
          <a href="mailto:contacto@aeronautica360.com.ar" className="hover:text-slate-200 transition-colors" data-id="element-102">
            📧 contacto@aeronautica360.com.ar
          </a>
          <span className="hidden sm:inline" data-id="element-103">·</span>
          <span className="hover:text-slate-200 transition-colors" data-id="element-104">
            📱 @aeronautica360
          </span>
        </div>

        <div className="text-xs text-slate-600 border-t border-slate-800 pt-8 space-y-3" data-id="element-105">
          <p data-id="element-106">
            © 2026 MegaPack Técnico en Aeronáutica 360 — Todos los derechos
            reservados.
          </p>
          <p className="italic text-slate-400/80" data-id="element-107">
            "El MegaPack Técnico en Aeronáutica 360 no te convierte en mejor
            docente. Vos ya sos un buen docente. Lo que hace el MegaPack es
            darte el tiempo y las herramientas para que eso se note en cada
            clase."
          </p>
        </div>
      </div>
    </footer>;
}